import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { COLUMNS_TYPES, COLUMNS_VALUES_KEYS, } from '../../../../data/data1d/multipleSpectraAnalysis';
import DeleteButton from '../../../elements/Tab/DeleteButton';
import DropDownButton from '../../../elements/dropDownButton/DropDownButton';
import { useHighlight } from '../../../highlight/index';
const styles = {
    container: {
        position: 'relative',
        padding: '0.15rem 0.4rem',
        height: '100%',
    },
    deleteButton: {
        position: 'absolute',
        right: 0,
        top: 0,
    },
    innerContainer: {
        display: 'flex',
        flexDirection: 'column',
        padding: 0,
        margin: 0,
    },
    dropdownContainer: {
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
    },
    labelContainer: {
        flex: '1',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        minHeight: '45px',
    },
    label: {
        textAlign: 'center',
    },
};
const columnsFilters = [
    { key: COLUMNS_VALUES_KEYS.RELATIVE, label: 'Relative' },
    { key: COLUMNS_VALUES_KEYS.ABSOLUTE, label: 'Absolute' },
    { key: COLUMNS_VALUES_KEYS.MIN, label: 'Min Intensity' },
    { key: COLUMNS_VALUES_KEYS.MAX, label: 'Max Intensity' },
];
function AnalysisColumnHeader({ columnKey, rangeLabel, data, onColumnFilter, onDelete, }) {
    const highlight = useHighlight([columnKey]);
    function deleteHandler(e) {
        e.stopPropagation();
        onDelete();
    }
    return (_jsxs("div", { style: { ...styles.container, ...highlight.defaultActiveStyle }, ...highlight.onHover, children: [_jsxs("div", { style: styles.innerContainer, children: [data.type === COLUMNS_TYPES.NORMAL && (_jsx("div", { style: styles.dropdownContainer, children: _jsx(DropDownButton, { data: columnsFilters, formatSelectedValue: (item) => item.label.slice(0, 3), selectedKey: data.valueKey, onSelect: onColumnFilter }) })), _jsxs("div", { style: styles.labelContainer, children: [_jsxs("span", { style: styles.label, children: [" ", columnKey] }), _jsx("span", { style: styles.label, children: rangeLabel })] })] }), _jsx(DeleteButton, { onDelete: deleteHandler, style: styles.deleteButton })] }));
}
export default AnalysisColumnHeader;
